import React from "react";
import SegmentPage from "../components/aa/SegmentPage";
import { HEALTH_TRANSLATIONS, HEALTH_IMAGES } from "../data/health";

export default function HealthPage() {
  return <SegmentPage translations={HEALTH_TRANSLATIONS} images={HEALTH_IMAGES} />;
}
